import PropTypes from 'prop-types';
import React from 'react';
import { COLORS, PROMOTION_TYPES } from '../utils/constants';
import { CardSubTitle } from './bootstrap/Card';
import Icon from './icon/Icon';
import Alert from './bootstrap/Alert';
import Popovers from './bootstrap/Popovers';
import { createDateString } from '../utils/util_funcs';

const PromotionAlert = ({ promotionMetadata }) => {
	return (
		promotionMetadata.type === PROMOTION_TYPES.FINANCING && (
			<div className='col-12'>
				<Alert
					className='mb-0'
					color={COLORS.SUCCESS.name}
					icon='TagsFill'
					style={{
						display: 'grid',
						gridTemplateColumns: 'auto 1fr',
						alignItems: 'center',
						gap: '1rem',
						padding: '1.5rem',
					}}>
					<div className='alert-text'>
						<CardSubTitle
							tag='h5'
							className='h5 mb-2'
							style={{
								display: 'flex',
								flexWrap: 'wrap',
							}}>
							{`${promotionMetadata.name}`}{' '}
							<Popovers desc={promotionMetadata.disclaimerText} trigger='hover'>
								<Icon
									className='pointerOnHover'
									icon='InfoOutline'
									styles={{
										marginLeft: '0.4rem',
										marginRight: '0.1rem',
										marginBottom: '0.2rem',
									}}
								/>
							</Popovers>
						</CardSubTitle>
						{/* Make backwards compatible by making sure maxTermForLowestRate is defined */}
						<p className='mb-0'>
							{promotionMetadata.maxTermForLowestRate ? (
								<>
									Rates as low as{' '}
									<b>{`${
										Math.round(promotionMetadata.lowestRate * 100 * 100) / 100
									}%`}</b>{' '}
									APR for up to <b>{promotionMetadata.maxTermForLowestRate}</b>{' '}
									months. Terms apply. Offer valid through{' '}
									{createDateString(promotionMetadata.endsAt)}. No down payment
									for well-qualified buyers.
								</>
							) : (
								<>
									Rates as low as{' '}
									<b>{`${
										Math.round(promotionMetadata.lowestRate * 100 * 100) / 100
									}%`}</b>{' '}
									APR. Terms apply. Offer valid through{' '}
									{createDateString(promotionMetadata.endsAt)}. No down payment
									for well-qualified buyers.
								</>
							)}
						</p>
					</div>
				</Alert>
			</div>
		)
		// ADD OTHER PROMOTION TYPES HERE
	);
};

PromotionAlert.propTypes = {
	// eslint-disable-next-line react/forbid-prop-types
	promotionMetadata: PropTypes.object.isRequired,
};

export default PromotionAlert;
